import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { debounce } from 'common/helpers/actions'
import { intlMessageShape } from 'sb-react-intl'

import SelectizeView from 'components/forms/selectize/SelectizeView/SelectizeView'
import selectizeState from 'components/forms/selectize/selectizeState'


class SelectizeSearch extends Component {

  static propTypes = {
    className: PropTypes.string,
    inputValue: PropTypes.string,
    fetchAction: PropTypes.func.isRequired, // action to fetch options
    optionRender: PropTypes.func, // custom item renderer
    placeholder: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape(intlMessageShape),
    ]),
    error: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape(intlMessageShape),
    ]),
    inputId: PropTypes.string,
    optionsId: PropTypes.string,
    withMagnifierIcon: PropTypes.bool,
  }

  static defaultProps = {
    withMagnifierIcon: true,
  }

  static contextTypes = {
    selectize: PropTypes.object,
  }

  state = {
    isFetching: false,
    options: [],
  }

  resolveOptions = debounce((inputValue) => {
    const { fetchAction } = this.props

    if (inputValue === '') {
      this.setState({
        isFetching: false,
        options: [],
      })
    }
    else {
      this.setState({
        isFetching: true,
      })

      fetchAction(inputValue)
        .then((options) => {
          this.setState({
            isFetching: false,
            options,
          })
        })
    }
  }, 300)

  componentDidMount() {
    const { selectize: { subscribeOnChange } } = this.context

    subscribeOnChange(this.resolveOptions)
  }

  render() {
    const { isFetching, options } = this.state
    const { className, inputValue, optionRender, placeholder, error, withMagnifierIcon,
      inputId, optionsId } = this.props

    return (
      <SelectizeView
        className={className}
        placeholder={placeholder}
        error={error}
        options={options}
        optionRender={optionRender}
        inputValue={inputValue}
        inputId={inputId}
        optionsId={optionsId}
        withLoader={isFetching}
        withMagnifierIcon={withMagnifierIcon}
      />
    )
  }
}


export default selectizeState(SelectizeSearch)
